export const STATUS_COLOR_BY_APPLICATION_STATUS = {
  COMPLETED: '#008558',
  CANCELLED: '#DF2C2C',
  REJECTED: '#DF2C2C',
  PENDING: '#096BCE',
  IN_PROGRESS: '#096BCE',
  DRAFT: '#8C9099',
  RETURNED: '#D97706',
};

export const propertiesKeysMap = {
  ar: {
    community: 'communityAr',
    district: 'districtAr',
    plotNumber: 'plotNumber',
    unitNumber: 'unitNumber',
    buildingNumber: 'buildingNumber',
  },
  en: {
    community: 'communityEn',
    district: 'districtEn',
    plotNumber: 'plotNumber',
    unitNumber: 'unitNumber',
    buildingNumber: 'buildingNumber',
  },
};
